// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"baz_a bgu_g"};